import { Navigate, useLocation } from 'react-router-dom';
import { SignInCard } from '@kawai/auth-bootstrap';
import { useAuth } from '../lib/auth.js';
import { ROUTES } from '../routes.js';

interface LocationState {
  from?: string;
}

/**
 * S-89: フォーム本体は @kawai/auth-bootstrap の SignInCard に共通化。
 * ここは signed-in 時の遷移（fromPath）と app 固有の表示文言のみを担う。
 */
export function SignInPage() {
  const { status, signIn } = useAuth();
  const location = useLocation();
  const fromPath = (location.state as LocationState | null)?.from ?? ROUTES.home;

  if (status === 'signed-in') {
    return <Navigate to={fromPath} replace />;
  }

  return (
    <SignInCard
      logoSrc="/brand/tracepit-logo.png"
      tenantName="セルフ武生21SS"
      appTitle="顧客/販促"
      contactEmail="info@tracepit.jp"
      signIn={signIn}
      variant="v2"
    />
  );
}
